export class ProductosPeriodosGracias {
  id: number;
  idProductoPeriodoGracia: string;
  idProducto: string;
  idTipoPeriodoGracia: string;
  plazoMaximo: number;
  plazoMinimo: number;
  indicadorIntereses: boolean;
  indicadorCapital: boolean;
  indicadorOtrosConceptos: boolean;
  indicadorOpcional: boolean;
  indicadorHabilitado: boolean;
  auditoriaUsuario: string;
  auditoriaFecha: Date;
  tipoPeriodoGracia: string;

  constructor() {
    this.indicadorIntereses = false;
    this.indicadorCapital = false;
    this.indicadorOtrosConceptos = false;
    this.indicadorOpcional = false;
    this.indicadorHabilitado = true;

  }

}
